import { render, staticRenderFns } from "./UrgentAlert.vue?vue&type=template&id=75219ecf"
import script from "./UrgentAlert.vue?vue&type=script&lang=js"
export * from "./UrgentAlert.vue?vue&type=script&lang=js"
import style0 from "./UrgentAlert.vue?vue&type=style&index=0&id=75219ecf&lang=scss"
import style1 from "./UrgentAlert.vue?vue&type=style&index=1&id=75219ecf&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75219ecf')) {
      api.createRecord('75219ecf', component.options)
    } else {
      api.reload('75219ecf', component.options)
    }
    module.hot.accept("./UrgentAlert.vue?vue&type=template&id=75219ecf", function () {
      api.rerender('75219ecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modal/UrgentAlert.vue"
export default component.exports